import React, { useContext } from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { ShopByCategory as ShopByCategoryComponent } from '@thd-olt-component-react/shop-by-category';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from './context/HomepageContext';
import { CUSTOMER_TYPES } from '../utils/index';

export function ShopByCategory({ id }) {
  const { customerType } = useContext(HomepageContext);
  const isB2C = customerType === CUSTOMER_TYPES.B2C || customerType === CUSTOMER_TYPES.GUEST;

  return (
    <ErrorBoundary name="shop-by-category">
      <QueryProvider key={id} cacheKey={id}>
        <div
          id={`shop-by-category-php-${id}`}
          className="sui-h-full"
        >
          <ImpressionProvider
            data={{
              id,
              name: 'ShopByCategory',
              component: 'ShopByCategory',
              type: 'content',
              position: '',
            }}
          >
            <ShopByCategoryComponent
              componentId={id}
              componentClass="ShopByCategory"
              enableB2CGapAndPadding={isB2C}
            />
          </ImpressionProvider>
        </div>
      </QueryProvider>
    </ErrorBoundary>
  );
}

ShopByCategory.propTypes = {
  id: string,
};

ShopByCategory.defaultProps = {
  id: undefined,
};
